// extracted by mini-css-extract-plugin
module.exports = {"button":"DefaultTag_button__0Dw77","button__counter":"DefaultTag_button__counter__64UpQ","skeleton":"DefaultTag_skeleton__j5Mhu","skeleton-rect":"DefaultTag_skeleton-rect__aV_Ck"};